module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.$store.commit('setOverlay', null)
      }
    }
  }, [_c('div', {
    staticClass: "close-but"
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "overlay-content"
  }, [_c('div', {
    staticClass: "instagram"
  }, [_c('img', {
    attrs: {
      "src": _vm.gram.images.standard_resolution.url
    }
  }), _vm._v(" "), (_vm.gram.type === 'youtube') ? _c('iframe', {
    attrs: {
      "width": "420",
      "height": "315",
      "src": 'https://www.youtube.com/embed/' + _vm.gram.id
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outside"
  }, [(_vm.gram.type === 'youtube') ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/watch?v=' + _vm.gram.id,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "profile",
    style: ({
      backgroundImage: 'url(' + _vm.gram.user.profile_picture + ')'
    })
  }), _vm._v(" " + _vm._s(_vm.gram.user.username))]) : _vm._e(), _vm._v(" "), (_vm.gram.type !== 'youtube') ? _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.gram.user.username,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "profile",
    style: ({
      backgroundImage: 'url(' + _vm.gram.user.profile_picture + ')'
    })
  }), _vm._v(" " + _vm._s(_vm.gram.user.username))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hearts"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v(" " + _vm._s(_vm.gram.likes.count))])])]), _vm._v(" "), (_vm.gram.color === 'blue') ? _c('a', {
    staticClass: "product product-blue",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  }) : _c('a', {
    staticClass: "product product-grey",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e0785f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overlay.vue
// module id = 227
// module chunks = 1